import * as ACTION_TYPES from "../types";

let initialState = {
  loading: false,
  error: false,
  paymentChannels: [],
  binProfilePaymentChannels: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_PAYMENT_CHANNELS:
      return { ...state, paymentChannels: action.data };
    case ACTION_TYPES.GET_BIN_PROFILE_PAYMENT_CHANNELS:
      return { ...state, binProfilePaymentChannels: action.data };
    default:
      return state;
  }
};
